import { GridColumnGroupHeaderParams } from '@mui/x-data-grid-pro';
import { ReactNode } from 'react';

import { Icon, IconIdUnion } from '~/components/Icon';

export const headerGroupWithIcon =
  (icon: IconIdUnion) =>
  (params: GridColumnGroupHeaderParams): ReactNode => {
    return (
      <>
        {params.headerName}
        <Icon sx={{ marginLeft: 1 }} id={icon} fontSize="small" />
      </>
    );
  };
